import { TableRow } from '@shared/UI';

interface Options {
    onOrderRowClick: (order: any) => void;
}

export function getOrderTableRows(option: Options): TableRow<any> {
    const { onOrderRowClick } = option;
    return { onClick: (row) => () => onOrderRowClick(row) };
}
